import React from 'react';
import { ButtonGrid, Container, WashButton } from './StartWashingMachineStyles';
import axios from 'axios';

const StartWashingMachine: React.FC = () => {
  const handleWashClick = async (washingType: string) => {
    const baseUrl = 'https://api.redezandona.com.br/api/v1/machine/publish';
    const url = `${baseUrl}?id=z7mach1&washingType=${washingType}&action=on`;

    try {
      const response = await axios.get(url);
      console.log(`Requisição bem-sucedida para ${washingType}:`, response.data);
    } catch (error) {
      console.error(`Erro ao enviar comando ${washingType}:`, error);
    }
  };

  return (
    <Container>
      <ButtonGrid>
        <WashButton onClick={() => handleWashClick('L1')}>Lavação 1</WashButton>
        <WashButton onClick={() => handleWashClick('L2')}>Lavação 2</WashButton>
        <WashButton onClick={() => handleWashClick('L3')}>Lavação 3</WashButton>
        <WashButton onClick={() => handleWashClick('L4')}>Lavação 4</WashButton>
      </ButtonGrid>
    </Container>
  );
};

export default StartWashingMachine;
